export const menuArray = [
    {
        tag: "Casos jurídicos",
        link: "casos",
        privileges: 1,
        data: [
            {
                title: "Nuevo",
                link: "casos/nuevo"
            },
            {
                title: "Control de legalidad",
                link: "casos/control"
            },
            {
                title: "Banco temático de casos",
                link: "casos/buscar"
            },
            {
                title: "Historial de seguimiento",
                link: "casos/historial"
            }
        ]
    },
    {
        tag: "Tareas",
        link: "tareas",
        privileges: 1,
        data: []
    },
    {
        tag: "Clientes",
        link: "clientes",
        privileges: 1,
        data: [
            {
                title: "Nuevo",
                link: "clientes/nuevo"
            }
        ]
    },
    {
        tag: "Aseguradoras",
        link: "aseguradoras",
        privileges: 2,
        data: [
            {
                title: "Nuevo",
                link: "aseguradoras/nuevo"
            }
        ]
    },
    {
        tag: "Órganos de investigación",
        link: "organos-investigacion",
        privileges: 1,
        data: [
            {
                title: "Nuevo",
                link: "organos-investigacion/nuevo"
            }
        ]
    },
    {
        tag: "Usuarios",
        link: "usuarios",
        privileges: 2,
        data: [
            {
                title: "Nuevo",
                link: "usuarios/nuevo"
            }
        ]
    },
    {
        tag: "Reportes",
        link: "reportes",
        privileges: 2,
        data: []
    },
    {
        tag: "Cargue masivo",
        link: "cargue",
        privileges: 2,
        data: []
    },
];